import './HelpButton.css';
import React from 'react';

interface HelpButtonProps {
  isOpen: boolean;
  onClick: (isOpen: boolean) => void;
}

export default function HelpButton({
  isOpen,
  onClick,
}: HelpButtonProps) {
  return (
    <div className="help">
      <button
        title={isOpen ? 'hide help' : 'show help'}
        children={isOpen ? '×' : '?'}
        onClick={() => onClick(!isOpen)}
        className={`show-hide-help ${isOpen ? 'open' : 'closed'}`}
      />
    </div>
  );
}

interface HelpTextProps {
  text: React.ReactNode;
  isOpen: boolean;
  showTitle?: boolean;
}

export function HelpText({
  text,
  isOpen,
  showTitle = true,
}: HelpTextProps) {
  return isOpen ? (
    <div className="explain">
      { showTitle && <h3>What's this?</h3> }
      { text }
    </div>
  ) : null;
}
